import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseModalComponent } from '@card-software/library';

@Component({
  selector: 'app-lots-id-modal',
  templateUrl: './lots-id-modal.component.html',
})
export class LotsIdModalComponent extends BaseModalComponent<string | null> {
  lotForm: FormGroup;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
  ) {
    super(injector);

    this.lotForm = this.fb.group({
      lotId: new FormControl('', [Validators.required]),
    });
  }

  onSave(): void {
    if (this.lotForm.invalid) return;

    const trimmedLotId = this.lotForm.get('lotId')?.value.trim();
    if (trimmedLotId) {
      this.close({ action: 'save', data: trimmedLotId });
    }
  }

  onClose(): void {
    this.close({ action: 'cancel', data: null });
  }
}
